import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { TemplateFile } from '../template/template-file.model';

/** A dumb class that temporarily solves the cycle dependency problem. */
@Injectable({ providedIn: 'root' })
export class ImportTemplateNotifierService {
  private readonly templateImported$$ = new Subject<TemplateDetails>();
  public readonly templateImported$ = this.templateImported$$.asObservable();

  emitTemplate(template: TemplateDetails) {
    this.templateImported$$.next(template);
  }
}

export interface TemplateDetails extends TemplateFile {
  integrations: string[];
  title: string;
}
